// Content Management API helpers — auth via localStorage JWT.
import { getToken, clearToken } from './adminApi';

const BASE = process.env.REACT_APP_BACKEND_URL;

async function _req(path, opts = {}) {
  const token = getToken();
  const isFormData = opts.body instanceof FormData;
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = res.status === 401 ? 'Unauthorized' : 'Request failed';
    try {
      const b = await res.json();
      if (b?.detail) detail = typeof b.detail === 'string' ? b.detail : JSON.stringify(b.detail);
    } catch (_) { /* ignore */ }
    if (res.status === 401 && token) clearToken();
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.status === 204 ? null : res.json();
}

// ---------- Content (KV) ----------
export function getContent(key) {
  return _req(`/api/content/${encodeURIComponent(key)}`);
}
export function getAllContent() {
  return _req('/api/content');
}
export function adminListContent() {
  return _req('/api/admin/content');
}
export function adminUpsertContent(key, value) {
  return _req(`/api/admin/content/${encodeURIComponent(key)}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  });
}

// ---------- Universities ----------
export function listUniversities() {
  return _req('/api/universities');
}
export function getUniversity(slug) {
  return _req(`/api/universities/${encodeURIComponent(slug)}`);
}
export function adminCreateUniversity(payload) {
  return _req('/api/admin/universities', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function adminUpdateUniversity(slug, payload) {
  return _req(`/api/admin/universities/${encodeURIComponent(slug)}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}
export function adminDeleteUniversity(slug) {
  return _req(`/api/admin/universities/${encodeURIComponent(slug)}`, {
    method: 'DELETE',
  });
}
export function adminUploadUniversityBuilding(slug, file) {
  const fd = new FormData();
  fd.append('file', file);
  return _req(`/api/admin/universities/${encodeURIComponent(slug)}/building-image`, {
    method: 'POST',
    body: fd,
  });
}
export function adminDeleteUniversityBuilding(slug) {
  return _req(`/api/admin/universities/${encodeURIComponent(slug)}/building-image`, {
    method: 'DELETE',
  });
}

// ---------- Generic media upload ----------
export function adminUploadMedia(file, folder = 'misc') {
  const fd = new FormData();
  fd.append('file', file);
  return _req(`/api/admin/media/upload?folder=${encodeURIComponent(folder)}`, {
    method: 'POST',
    body: fd,
  });
}
